import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import WithRouter from 'custom/withRouter';
import LOOKUP from 'constants/lookup';
import { reportBrandSalesReportCrumb } from 'utils/breadcrumbInfo';
import { checkDateRange } from 'utils/helpers';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getBrandSales, getCsvReport } from 'actions/ReportsAction';
import { showError } from 'actions/CommonActions';
// Basic Components
import PageHeader from 'screens/components/basic/PageHeader';
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import Pagination from 'screens/components/basic/Pagination';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import Body from './Body';
import Header from './Header';

class BrandReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showBody: false,
            activePage: 1,
            itemsPerPage: 20,
            totalRow: 0
        }
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        this.cleanSearch();
        const date = new Date();
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1), `BrandSalesBeginDate`);
        this.props.formInput(date, `BrandSalesEndDate`);
    }

    cleanSearch = () => {
        this.props.clearFormInput(`BrandSalesBeginDate`);
        this.props.clearFormInput(`BrandSalesEndDate`);
        this.props.clearFormInput(`BrandSalesBranchOption`);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).add(1, "days").format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let pageSize = this.state.itemsPerPage;
        let pageNumber = this.state.activePage;

        this.props.getBrandSales({ beginDate, endDate, branch, pageNumber, pageSize });
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).add(1, "days").format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/brandsales?beginDate=${beginDate}&endDate=${endDate}&branch=${branch}`, "Brandsales");
        }
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.getReport();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    componentWillReceiveProps = (newProps) => {
        if (newProps !== this.props) {
            if (this.state.showBody) {
                const totalRow = newProps.brandSales && newProps.brandSales.list && newProps.brandSales.list.length > 0 ? newProps.brandSales.total : 0;
                this.setState({ totalRow: totalRow })
            }
        }
    }

    render() {

        return (
            <Grid headerContent={reportBrandSalesReportCrumb}>
                <PageHeader title={LOOKUP.report.brandSales.text} description={LOOKUP.report.brandSales.description} icon={<KnowledgeBase />} />
                {(!this.props.branchOptions || this.props.branchOptions.length == 0) &&
                    <div style={{ color: `#FF4C5B` }} className="row m-0 pa-2"><h5>No branches available to query</h5></div>}
                <Header
                    branchOptions={this.props.branchOptions}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch.toString()}
                />
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body
                            brandSales={this.props.brandSales}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                        />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    return {
        branchOptions: branchOptions,
        brandSales: state.reports.brandSales,
        loggedBranch: state.common.branchId,
        beginDate: state.form.BrandSalesBeginDate,
        endDate: state.form.BrandSalesEndDate,
        branch: state.form.BrandSalesBranchOption,
        store: state.common.store
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getBrandSales: (model) => dispatch(getBrandSales(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(BrandReport));
